module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"cancel":"キャンセル","create":"自分の情報を登録する","update":"自分の情報を修正する","edit":"修正","apply":"適用","reset":"解除"}}')
  delete Component.options._Ctor
}
